import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { VocalEffects } from "constants/vocalPresets";

import { featureFlagsInitialState } from "./constant";

const featureFlagsSlice = createSlice({
	name: "featureFlags",
	initialState: featureFlagsInitialState,
	reducers: {
		toggleSongListPlayNow: (state) => {
			state.songListPlayNow = !state.songListPlayNow;
		},
		toggleUseNativeKeyboard: (state) => {
			state.useNativeKeyboard = !state.useNativeKeyboard;
		},
		toggleIsCameraActivated: (state) => {
			state.isCameraActivated = !state.isCameraActivated;
		},
		toggleIsVocalGuideActivated: (state) => {
			state.isVocalGuideActivated = !state.isVocalGuideActivated;
		},
		toggleIsPublicInteractionActivated: (state) => {
			state.publicInteraction.isActivated =
				!state.publicInteraction.isActivated;
		},
		toggleisPausedInteraction: (state, action: PayloadAction<boolean>) => {
			state.publicInteraction.isPaused = action.payload;
		},
		toggleVocalEffects: (state) => {
			state.vocalEffects = !state.vocalEffects;
		},
		toggleMusicEffects: (state) => {
			state.musicEffects = !state.musicEffects;
		},
		toggleRoulette: (state) => {
			state.isRouletteActivated = !state.isRouletteActivated;
		},
		toggleBlindTest: (state) => {
			state.isBlindTestActivated = !state.isBlindTestActivated;
		},
		setPublicInteractionSingerName: (
			state,
			action: PayloadAction<string | null>,
		) => {
			state.publicInteraction.publicSingerName = action.payload;
		},
		toggleIsIAPWebcamActivated: (state) => {
			state.isIAPWebcamActivated = !state.isIAPWebcamActivated;
		},
		setPublicInteractionRoomId: (state, action: PayloadAction<string>) => {
			state.publicInteraction.publicRoomId = action.payload;
			state.publicInteraction.isActivated = true;
			state.publicInteraction.isPaused = false;
		},
		setIsWaitingSongActivated: (state, action: PayloadAction<boolean>) => {
			state.publicInteraction.isWaitingSongActivated = action.payload;
		},
		toggleIsChildSafe: (state) => {
			state.isChildSafe = !state.isChildSafe;
		},
		setSelectedVocalEffect: (state, action: PayloadAction<VocalEffects>) => {
			state.selectedEffect = action.payload;
		},
		setIsAirconsoleActivated: (state) => {
			state.isAirconsoleActivated = !state.isAirconsoleActivated;
		},
		toggleIsPromoActivated: (state) => {
			state.isTvPromoActivated = !state.isTvPromoActivated;
		},
		toggleIsSuggestedTitleActivated: (state) => {
			state.isSuggestedTitleActivated = !state.isSuggestedTitleActivated;
		}
	},
});

export const {
	toggleSongListPlayNow,
	toggleUseNativeKeyboard,
	toggleIsCameraActivated,
	toggleIsVocalGuideActivated,
	toggleIsPublicInteractionActivated,
	setPublicInteractionSingerName,
	setPublicInteractionRoomId,
	setIsWaitingSongActivated,
	toggleisPausedInteraction,
	toggleVocalEffects,
	toggleMusicEffects,
	toggleIsChildSafe,
	toggleIsIAPWebcamActivated,
	setSelectedVocalEffect,
	toggleIsPromoActivated,
	toggleRoulette,
	toggleBlindTest,
	setIsAirconsoleActivated,
	toggleIsSuggestedTitleActivated,
} = featureFlagsSlice.actions;

export default featureFlagsSlice.reducer;
